import React from "react";
import {useTranslation} from "react-i18next";
//local
import {Select} from "antd";
import {orderingCreatedValues, orderingNameValues} from "constants/select.consts";
import {changeSelectValue, changeFilterParams} from "helpers/helper";
import ProjectsSelect from "components/selects/ProjectsSelect";

const {Option} = Select;

const ContractsToUsTableHead = ({
  projects,
  filters,
  isBuyer,
  onChangeProject,
  onChangeOrder,
  showContractNumber,
}) => {
  const {t} = useTranslation();
  const allProjectItem = {id: null, name: t("ALL_PROJECTS"), isArchived: false};

  const handleChangeOrder = (value) => onChangeOrder(changeFilterParams(value));

  const options = (values) =>
    values.map(({value, label}, i) => (
      <Option key={i} value={value}>
        {t(label)}
      </Option>
    ));

  return (
    <div className="requests-card_head">
      <div className="requests-card_head__icon __wrapper icon-col"></div>
      {showContractNumber && (
        <div className="requests-card_head__number __wrapper number-col">
          {/* {t("CONTRACT_NUMBER_TABLE_HEADER")} */}
        </div>
      )}

      <div className="requests-card_head__name __wrapper name-col">
        <div className="requests-card_head__name __select mr-2">
          <Select
            onChange={handleChangeOrder}
            value={changeSelectValue(orderingNameValues, filters)}
          >
            {options(orderingNameValues)}
          </Select>
        </div>
      </div>
      <div className="requests-card_head__column __wrapper company-col">
        {t(isBuyer ? "SUPPLIER" : "BUYER")}
      </div>
      <div className="requests-card_head__column __wrapper date-col">
        <div className="requests-card_head__name __select">
          <Select
            onChange={handleChangeOrder}
            value={changeSelectValue(orderingCreatedValues, filters)}
          >
            {options(orderingCreatedValues)}
          </Select>
        </div>
      </div>
      <div className="requests-card_head__column __wrapper project-col">
        {!!projects?.length && (
          <ProjectsSelect
            list={[allProjectItem, ...projects]}
            onChange={onChangeProject}
            noBorder
            addClass="contracts-project-label"
            defaultValue={allProjectItem.id}
          />
        )}
      </div>
    </div>
  );
};
export default ContractsToUsTableHead;
